var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c(
        "BaseFormField",
        {
          attrs: {
            label: _vm.label,
            "hide-label": _vm.hideLabel,
            "has-tooltip": _vm.hasTooltip,
            "tooltip-text": _vm.tooltipText
          }
        },
        [_vm._t("element")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }